import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/nested.php
export default {
	run: function(filter, data, config, global) {
		global.nested = {}
		var nestedIds = Object.keys(global.nestedIndex || {}).map(function(id) {
			return parseInt(id, 10)
		}).filter(function(id) {
			return !!id
		})
		if (!nestedIds.length) return

		if (config.ownerType === F.OWNER_USER) {
			var rows = DB.query('SELECT collection_id, collection_nested, collection_nested_custom, collection_nested_official FROM collection WHERE collection_id IN(' + Util.in(nestedIds) + ') AND collection_nested > 0', [])
			for (var i = 0; i < rows.length; i++) {
				var parentId = rows[i].collection_nested === F.NESTED_OFFICIAL
					? rows[i].collection_nested_official
					: rows[i].collection_nested_custom
				if (!global.nested[parentId]) global.nested[parentId] = []
				global.nested[parentId].push(rows[i].collection_id)
			}
			return
		}

		var gameRows = DB.query('SELECT game_id, game_base FROM game WHERE game_id IN(' + Util.in(nestedIds) + ')', [])
		for (var j = 0; j < gameRows.length; j++) {
			var bases = []
			try {
				bases = JSON.parse(gameRows[j].game_base || '[]') || []
			} catch (e) {
				bases = []
			}
			for (var bi = 0; bi < bases.length; bi++) {
				if (!global.nested[bases[bi]]) global.nested[bases[bi]] = []
				global.nested[bases[bi]].push(gameRows[j].game_id)
			}
		}
	}
}
